/* Swiper Partners*/

var swiper = new Swiper(".partners-slider", {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    autoplay: {
        delay: 3000,
        pauseOnMouseEnter : true,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },

    breakpoints: {
        // when window width is >= 640px
        640: {
            slidesPerView: 3,
            spaceBetween: 30,
            loop: true,
        },

        // when window width is >= 769px
        769: {
            slidesPerView: 5,
            spaceBetween: 30,
            loop: true,
        },
    }
});

/* Swiper Appointments*/

var swiper = new Swiper(".slider-appointments", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
        delay: 5000,
        pauseOnMouseEnter : true,
        disableOnInteraction: false,
    },
    breakpoints: {
        // when window width is >= 640px
        640: {
            slidesPerView: 2,
            spaceBetween: 30,
            loop: false,
        },

        // when window width is >= 769px
        769: {
            slidesPerView: 2,
            spaceBetween: 30,
            loop: false,
        },

        // when window width is >= 769px
        992: {
            slidesPerView: 3,
            spaceBetween: 30,
            autoplay: false,
            loop: false,
        },
        
        // when window width is >= 769px
        1300: {
            slidesPerView: 4,
            spaceBetween: 10,
            autoplay: false,
            loop: false,
        },
    }
});

/* Swiper Appointments*/

var swiper = new Swiper("#slider-header", {
    slidesPerView: 1,
    spaceBetween: 5,
    loop: true,
    speed: 2000,
    autoplay: {
        delay: 5000,
        pauseOnMouseEnter : true,
        disableOnInteraction: false,
    },
});